@for (value of values; track $index; let i = $index) {
<div class="history-version-card">
    <div class="history-version-header">
        <hr class="h-2 bg-valamardarkgray rounded-xl w-[10rem]">
        <p class="whitespace-nowrap text-black">Verzija {{ value.version }}</p>
        <hr class="h-2 bg-valamardarkgray rounded-xl w-full">
    </div>

    <div class="history-meta-grid">
        <div>
            <b>Izmjena:</b><p class="ml-5 inline-block">{{ value.modifiedByUser }}</p>
        </div>
        <div>
            <b>Vrijeme izmjene:</b><p class="ml-5 inline-block">{{ value.modifiedDate | date: "dd.MM.yyyy., HH:mm:ss" }}</p>
        </div>
    </div>
    <div class="history-state-row">
        <div class="flex items-center">
            <b>Aktivan:</b><mat-icon class="ml-5">{{ value.isActive ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        </div>
        <div class="flex items-center">
            <b>Skica:</b><mat-icon class="ml-5">{{ value.isDraft ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        </div>
    </div>
    <div>
        <b>Naziv
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="valben-inline-select">
                <mat-select [(ngModel)]="nameLangs[i]">
                    @for (lang of value.names | objKeys; track lang) {
                        <mat-option [value]="lang">{{ lang }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>:</b>
        <p class="ml-5">{{ value.names[nameLangs[i]] }}</p>
    </div>
    <div>
        <b>Opis
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="valben-inline-select">
                <mat-select [(ngModel)]="descLangs[i]">
                    @for (lang of value.descriptions | objKeys; track lang) {
                        <mat-option [value]="lang">{{ lang }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>:</b>
        <p class="ml-5">{{ value.descriptions[descLangs[i]] | stripHtml }}</p>
    </div>
    <div>
        <b>Link na sliku:</b>
        @if (value.imageUrl) {
            <a href="{{ value.imageUrl }}" target="_blank" class="break-all ml-5 hover:text-valamarbluesecondary cursor-pointer">{{ value.imageUrl }}</a>
        } @else {
            <p class="inline-block ml-5">/</p>
        }
    </div>
    <div>
        <b>Vanjska poveznica:</b>
        @if (value.link) {
            <a href="{{ value.link }}" target="_blank" class="break-all ml-5 hover:text-valamarbluesecondary cursor-pointer">{{ value.link }}</a>
        } @else {
            <p class="inline-block ml-5">/</p>
        }
    </div>
</div>
}
